<template>
  <a-modal
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :title="'充值'"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <div :style="{margin:'0px 20px 20px 20px'}">
        <a-alert message="友情提示：充值5万以上金额的用户，请联系客服申请专属优惠政策。" type="info" />
      </div>
      <a-form :form="form">
        <a-form-item label="购买数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择"
            v-decorator="['product_type', {rules: [{required: true, message: '必填项'}]}]"
          >
            <template v-for="(item,index) in goods">
              <a-select-option
                :key="index"
                :value="item.id"
              >{{item.rmb_price/100}}元（{{item.nb_amount/100}}NB+赠送{{item.reward_amount/100}}NB）</a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import PropertyAccountApi from '@/api/property-account'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this),
      goods: []
    }
  },
  computed: {},
  created() {
    this.getData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      const that = this
      const main_id = this.userInfo().id
      this.form.validateFields((err, values) => {
        if (!err) {
          PropertyAccountApi.createAlipayBuyNbOrder({
            product_type: values.product_type,
            product_number: 1,
            main_id: main_id
          }).then(link => {
            window.open(link)
            this.$confirm({
              title: '请在新窗口中完成支付',
              okText: '已完成支付',
              cancelText: '关闭',
              onOk() {
                that.visible = false
                that.$emit('ok')
              }
            })
          })
        }
      })
    },
    getData() {
      PropertyAccountApi.getGoods({}).then(res => {
        this.goods = res.data
      })
    }
  }
}
</script>
<style lang="less">
</style>
